import React from "react"
import { Outlet } from "react-router-dom"

import NavFooter from "../../components/NavFooter/NavFooter"
import Footer from "../Footer/Footer"
import Header from "../Header/Header"
import useSiteTitle from "../../hooks/use-site-title"

import styles from "./GeneralLayout.module.scss"

const GeneralLayout = () => {
  return (
    <div className={styles.content}>
      {/* Main header */}
      <Header
        data={{
          titulo: useSiteTitle(),
        }}
      />

      {/* Main content */}
      <main className={styles.main}>
        <div className={styles.container}>
          <Outlet />
        </div>
      </main>

      {/* Site footer */}
      <Footer areaB={<NavFooter />} />
    </div>
  )
}

export default GeneralLayout